import PlainItemsSelectorBox from 'app/common/ui-next/_filter-compilations/plain-items-selector-box'
import { encashmentsStatusFilter, encashmentsStatusFilterSelection, defaultEncashmentsStatusSelection } from 'app/dataProviders/filter-items'


type Props = {
  id: string
  pending: boolean
}



export const EncashmentsStatusFilter = ({ id, pending }: Props) => {
  return (
    <PlainItemsSelectorBox
      id={id}
      label="Статус"
      header="Выбор статуса"
      dataBoxData={encashmentsStatusFilter}
      dataBoxSelection={encashmentsStatusFilterSelection}
      pleaseSelectText="Нет данных"
      selectedAllOnEmptySelection
      disabled={pending}
      multiple
      defaultSelection={defaultEncashmentsStatusSelection}
    />
  )
}
